import { message } from "antd";

export const alphanumberRule = () => {
  return [
    {
      pattern: /^[a-zA-Z0-9 ]+$/,
      message: "Only letters and numbers are allowed",
    },
  ];
};

export const NTIDRule = () => {
  return [{ pattern: /^[A-Za-z0-9_.@-]+$/, message: "Please enter a valid NT-ID" }];
};

export const mandatoryRule = (message) => {
  return [message ? { required: true, message } : { required: true }];
};

export const alphabetRule = () => {
  return [
    {
      pattern: /^[A-Za-z ]+$/,
      message: "Only letters are allowed",
    },
  ];
};

export const emailRule = () => {
  return [
    {
      type: "email",
    },
  ];
};

export const numbericRule = () => {
  return [
    {
      pattern: /^\d+$/,
      message: "Only numbers are allowed",
    },
  ];
};

export const phoneNumberRule = () => {
  return [
    {
      pattern: /^\d{10}$/,
      message: "Please enter a valid 10 digit phone number",
    },
  ];
};

export const pincodeRule = () => {
  return [
    {
      pattern: /^d{6}$/,
      message: "Please enter a valid 6 digit pin code",
    },
  ];
};

export const requiredMedicalQuestionRule = () => {
  return [{ required: true, message: "Please complete this question" }];
};

export const allowOnlyNumbers = (e) => {
  const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];

  if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};

export const compulsoryCheckRule = () => ({
  validator(_, value) {
    if (value === true) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("You must agree before submitting"));
  },
});
